export function NorthVancouverHero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/6a47826f193a293c2f66a93c39f8e1ce.jpg)'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      
      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 text-center text-white">
        <h1 className="font-['Fraunces'] text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          North Vancouver Short Term Rental Bylaws
        </h1>
        <p className="text-xl lg:text-2xl mb-8 leading-relaxed max-w-3xl mx-auto">
          Navigate zoning-specific regulations across District and City of North Vancouver with expert compliance guidance
        </p>
        <button 
          onClick={scrollToContact}
          className="bg-[#882629] text-white px-10 py-5 rounded-full text-lg font-medium hover:bg-[#6E1F22] transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl"
        >
          Get North Vancouver Compliance Help
        </button>
      </div>
    </section>
  );
}
